import { FC } from 'react';
import { ICustomer } from '../../../model';
import { LocationsGrid } from '../../../pages/locations/LocationsGrid';
import styles from './LocationsSection.module.scss';

export const LocationsSection: FC<{ customer: ICustomer }> = ({ customer }) => {
  return (
    <div className={styles.tableResponsiveWrapper}>
      <LocationsGrid
        forCustomer={true}
        customer={customer}
      />
    </div>
  );
};
